import { Component, Element, Host, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'me-separated-layout',
  styleUrl: 'me-separated-layout.scss',
  shadow: false,
})
export class MeSeparatedLayout {

  @Element() host: HTMLElement;

  @Prop() size = 'r';

  private separatorTemplate = document.createElement('template');
  private contentTemplate = document.createElement('template');

  /**
   * The Content Version
   *
   * Allows to force a re-render cycle of the component
   */
  @State() private contentVersion = 0;

  private contentObserver = new MutationObserver(this.handleContentChange.bind(this));

  componentDidLoad() {
    setTimeout(() => this.contentVersion++);
    this.observeTemplateSubtree(this.contentTemplate);
  }

  render() {
    const classList = [
      'me-separated-layout',
      `me-separated-layout--${this.size}`,
    ].join(' ');

    return (
      <Host class={classList}>
        <template ref={(el: HTMLTemplateElement) => this.separatorTemplate = el}>
          <slot name="separator" />
        </template>
        <template ref={(el: HTMLTemplateElement) => this.contentTemplate = el}>
          <slot />
        </template>
        <div
          class="me-separated-layout__content"
          ref={el => el.replaceChildren(...this.separatedContent())}
        />
      </Host>
    );
  }

  private childNodes(template: HTMLTemplateElement): Node[] {
    return Array.from(
      template.content.childNodes.length
        ? template.content.childNodes
        : template.childNodes);
  }

  private separatedContent(): Node[] {
    const separatorNodes = this.childNodes(this.separatorTemplate)
      .filter(el => el.nodeType === Node.ELEMENT_NODE);
    const contentNodes = this.childNodes(this.contentTemplate)
      .filter(el => el.nodeType === Node.ELEMENT_NODE);
    const separatedContent = [];

    const separator = document.createElement('div');
    separator.classList.add('me-separated-layout__separator');
    separator.replaceChildren(...separatorNodes.map(el => el.cloneNode(true)));

    contentNodes.forEach((node, index) => {
      const item = document.createElement('div');
      item.classList.add('me-separated-layout__item');
      item.appendChild(node.cloneNode(true));
      separatedContent.push(item);

      if (index < contentNodes.length - 1) {
        item.appendChild(separator.cloneNode(true));
      }
    });

    return separatedContent;
  }

  private handleContentChange() {
    this.contentVersion++; // force re-rendering of the component
  }

  private observeTemplateSubtree(template: HTMLTemplateElement) {
    this.contentObserver.observe(template, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
    });
  }
}
